import React, { useState, useCallback } from 'react';
import axios from 'axios';

// Components
import WpToastManager from 'Wpds/components/toast/WpToastManager';
import { WpButton } from 'Wpds/components/button';

// Hooks
import { useSignOut } from 'Shared/utils/hooks/use-sign-out';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useApp } from 'Shared/utils/hooks/use-app';

// Styles
import './UserChooseMembership.scss';

import JoinableOrganization from './JoinableOrganization/JoinableOrganization';

function UserChooseMembership() {
  const [isButtonsDisabled, setIsButtonsDisabled] = useState(false);
  const {
    app: {
      routes: { dashboard: dashboardRoute },
    },
  } = useApp();
  const {
    user: { joinableOrganizations },
  } = useCurrentUser();

  const redirectTo = useCallback(redirectPath => {
    window.location.href = redirectPath;
  }, []);

  const { handleSignOut } = useSignOut();

  const handleJoinOrganizationClick = useCallback(
    async organizationSlug => {
      try {
        setIsButtonsDisabled(true);
        const response = await axios('/user/choose_membership', {
          method: 'POST',
          headers: {
            accept: 'application/json',
            'X-CSRF-Token': (document.getElementsByName('csrf-token') as any)?.[0]?.content || 'unknown',
          },
          data: { new_organization: false, organization_slug: organizationSlug },
        });
        if (response.data?.error) WpToastManager.danger(response.data?.error);
        redirectTo(dashboardRoute);
      } catch (e) {
        setIsButtonsDisabled(false);
        WpToastManager.danger('Something went wrong!');
      }
    },
    [redirectTo, dashboardRoute]
  );

  const baseClassName = 'UserChooseMembership';

  return (
    <div className={baseClassName}>
      <h3 className={`${baseClassName}__title`}>Select Your Organization</h3>
      <p>Looks like your organization is on PI Perform! Join an organization or create a new one.</p>
      <div className="d-flex flex-column mb-4">
        {joinableOrganizations.map(organization => (
          <JoinableOrganization
            key={organization.slug}
            organization={organization}
            isJoinDisabled={isButtonsDisabled}
            onJoinClick={handleJoinOrganizationClick}
          />
        ))}
      </div>
      <WpButton variant="secondary" block size="lg" disabled={isButtonsDisabled} onClick={handleSignOut}>
        Sign Out
      </WpButton>
    </div>
  );
}

export default UserChooseMembership;
